import React from 'react';
import { observer } from 'mobx-react-lite';
import GroupsActionPanel from '../GroupsActionPanel';
import GroupsTable from '../GroupsTable';
import { DashboardWrapperStyled, TableWrapperStyled } from './styles';

const Dashboard: React.FC = observer(() => {
  return (
    <DashboardWrapperStyled>
      <GroupsActionPanel />
      <TableWrapperStyled>
        <GroupsTable />
      </TableWrapperStyled>
    </DashboardWrapperStyled>
  );
});

export default Dashboard;
